export default __webpack_public_path__ + "static/media/Avatar.ef5a0c16.jpg";